module.exports = __webpack_public_path__ + "static/media/defArtboard.2bc8cbe0.jpg";